import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './Carousel.css';

const Carousel = ({ imagesWithText, interval = 3000 }) => {
  const settings = {
    autoplay: true,
    autoplaySpeed: interval,
    infinite: true,
    speed: 1000, // Slide transition speed
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false, // Disable arrows
    dots: false,   // Disable dots
    fade: true,    // Enable fade effect for smooth transitions
  };

  return (
    <div className="sliderss-container">
      <Slider {...settings} >
        {imagesWithText.map((item, index) => (
          <div key={index} className="images-slide">
            <img src={item.image} alt={`Slide ${index + 1}`} className="slides-image" />
            <div className='simages-overlay'/>
              
            
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
